import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import styles from './Hero.css'
import Framer from '../Framer/Framer'
import { FrameAnimation, FrameStates } from '../../constants/consts-types'
import PropTypes from 'prop-types'
import { getViewPortHeight, getViewPortWidth, isDesktop, isGuideLanding, isSMKGuide } from '../../services/service-utils'
import Review from '../Review/Review'
import { TypeComponentHero, TypeRoute } from '../../constants/consts-prop-types'
import { loadImage } from '../../services/service-image-loader'
import BackgroundImageParallax from './partials/BackgroundImageParallax'
import CategoryOrSubBrand from './partials/CategoryOrSubBrand'
import HeaderBoldLightSub from './partials/HeaderBoldLightSub'
import CTAs from './partials/CTAs'

class HeroFront extends Component {
  static propTypes = {
    data: TypeComponentHero,
    currentRoute: TypeRoute,
    frameFrom: PropTypes.string,
    frameTo: PropTypes.string,
    frameLeave: PropTypes.string
  }

  static defaultProps = {
    frameFrom: FrameStates.INIT_FRONT,
    frameTo: FrameStates.FRONT,
    frameLeave: FrameStates.LEAVE_FRONT,
  }

  constructor(props) {
    super(props)

    this.state = {
      frame: props.frameFrom,
      imageSrc: null,
      isDesktop: isDesktop(),
      viewportWidth: getViewPortWidth(),
      viewportHeight: getViewPortHeight()
    }

    this.onResize = this.onResize.bind(this)
    this.initAnimation = this.initAnimation.bind(this)
    this.resetText = this.resetText.bind(this)
    this.enterText = this.enterText.bind(this)
    this.renderReview = this.renderReview.bind(this)
  }

  componentDidMount() {
    this.resetText()

    window.addEventListener('resize', this.onResize)

    loadImage(this.props.data.image_url, this)

    this.setState({
      frame: this.props.frameFrom,
      viewportHeight: getViewPortHeight()
    }, () => {
      this.initAnimation()
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentRoute.id !== prevProps.currentRoute.id) {

      this.setState({
        frame: this.props.frameFrom
      })

      loadImage(null, this) // Reset image load transition
      loadImage(this.props.data.image_url, this)
      this.resetText()
      this.initAnimation()
    }
  }

  onResize() {
    if (this.state.viewportWidth === getViewPortWidth()) return

    this.setState({
      isDesktop: isDesktop(),
      viewportWidth: getViewPortWidth(),
      viewportHeight: getViewPortHeight()
    })
  }

  initAnimation() {
    setTimeout(() => {
      this.enterText()
      this.setState({
        frame: this.props.frameTo
      })
    }, FrameAnimation.ENTER_DELAY)
  }

  resetText() {
    window.TweenLite.set(this.nodeCat, { opacity: 0, transform: 'translateX(20px)' })
    window.TweenLite.set(this.nodeHead, { opacity: 0, transform: 'translateX(20px)' })
    if (this.nodeCTAs) window.TweenLite.set(this.nodeCTAs, { opacity: 0, transform: 'translateX(20px)' })
    if (this.nodeReview0) window.TweenLite.set(this.nodeReview0, { opacity: 0, transform: 'translateX(20px)' })
    if (this.nodeReview1) window.TweenLite.set(this.nodeReview1, { opacity: 0, transform: 'translateX(20px)' })
  }

  enterText() {
    const time = .9
    const del = '-=.4'
    this.tl = new window.TimelineLite()
    this.tl.stop()
    if (this.nodeCat) this.tl.add(window.TweenLite.to(this.nodeCat, time, { opacity: 1, transform: 'translateX(0)' }), del)
    if (this.nodeHead) this.tl.add(window.TweenLite.to(this.nodeHead, time, { opacity: 1, transform: 'translateX(0)' }), del)
    if (this.nodeCTAs) this.tl.add(window.TweenLite.to(this.nodeCTAs, time, { opacity: 1, transform: 'translateX(0)' }), del)
    if (this.nodeSMK) this.tl.add(window.TweenLite.to(this.nodeSMK, time, { opacity: 1, transform: 'translateY(0)' }), del)
    window.TweenLite.to(this.tl, 2.5, { progress: 1 })
  }

  renderReview(review, idx, className) {
    return (
      <div key={idx} className={className}>
        <Review data={review} />
      </div>
    )
  }

  render() {
    const { currentRoute } = this.props
    const { name: subBrand } = currentRoute.section || {}
    const isGuide = isSMKGuide(currentRoute)

    const {
      category,
      header_bold,
      header_light,
      header_sub,
      cta_primary,
      cta_secondary,
      colors,
      reviews,
      url,
      image_no_cropping
    } = this.props.data

    const {
      imageSrc,
      viewportHeight,
      frame,
      isDesktop
    } = this.state

    const stylesHero = {
      height: `${isGuide && !isGuideLanding(currentRoute)
        ? viewportHeight * 0.6
        : viewportHeight}px`,
      color: isGuide ? '#ffffff' : colors && colors.foreground ? colors.foreground : '',
      backgroundColor: colors && colors.background ? colors.background : ''
    }

    const hasReviews = Boolean(reviews && reviews.length > 0)

    const cssHero = [styles.Hero, (isGuide && styles.subBrand_Guide), (isGuideLanding(currentRoute) && styles.landing)].join(' ')

    return (
      <section
        // className={cssHero}
        className={[cssHero, (image_no_cropping && styles.imageNoCropping)].join(' ')}
        style={stylesHero}
      >

        <Framer
          className={image_no_cropping ? 'layoutNoCrop' : ''}
          state={frame}
          colors={colors}
          currentRoute={currentRoute}
        />

        {!image_no_cropping && (
          <BackgroundImageParallax imageSrc={imageSrc} disabled={isGuide} />
        )}

        <article className={styles.content}>
          <div className='container-fluid'>
            <div className={`row ${styles.contentLayout}`}>
              <div className={`h-full ${image_no_cropping ? 'col-md-6' : 'col-xs-12'}`}>
                <div className={`${styles.frontContainerFluid} ${!isDesktop ? 'container-fluid' : 'h-full'}`}>
                  <div className='row' style={{ display: 'none' }}>
                    <div className={`col-xs-11 ${!image_no_cropping ? 'col-md-5' : ''}`}>
                      <CategoryOrSubBrand
                        ref={node => this.nodeCat = node}
                        category={category}
                        subBrand={subBrand}
                        url={url}
                      />
                    </div>
                  </div>

                  <div className='row'>
                    <div className={`col-xs-11 col-md-offset-1 ${!image_no_cropping ? 'col-md-5' : ''}`}>
                      <HeaderBoldLightSub
                        ref={node => this.nodeHead = node}
                        header_bold={header_bold}
                        header_light={header_light}
                        header_sub={header_sub}
                      />
                    </div>
                  </div>

                  {image_no_cropping && !isDesktop && (
                    <div className='row' style={{ flexGrow: 1, marginTop: '1.25rem' }}>
                      <div className={`col-xs-12 col-md-11 col-md-offset-1`}>
                        <div
                          className={`${styles.imageNoCroppingContainer} ${styles.mobile}`}
                          style={imageSrc && { opacity: 1, backgroundImage: `url(${imageSrc})` }}
                        >
                          {/* Image placeholder */}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className='row' style={image_no_cropping && isDesktop ? { flexGrow: 1 } : {}}>
                    <div className={`col-xs-11 col-md-offset-1 ${!image_no_cropping ? 'col-md-5' : ''}`}>
                      <CTAs
                        ref={node => this.nodeCTAs = node}
                        cta_primary={cta_primary}
                        cta_secondary={cta_secondary}
                        cta_title={header_bold}
                      />
                    </div>
                    {hasReviews && isDesktop && !image_no_cropping &&
                      reviews.map((review, idx) => this.renderReview(review, idx, 'col-xs-11 col-md-2 col-md-offset-1'))
                    }
                  </div>

                  {hasReviews && isDesktop && image_no_cropping &&
                    <div className='row'>
                      {reviews.map((review, idx) => this.renderReview(review, idx, `col-xs-11 col-md-4 col-xs-offset-1`))}
                    </div>
                  }
                </div>

              </div>

              {image_no_cropping && (
                <div className={`col-md-6`}>
                  <div
                    className={styles.imageNoCroppingContainer}
                    style={imageSrc && { opacity: 1, backgroundImage: `url(${imageSrc})` }}
                  >
                    {/* placeholder for image */}
                  </div>
                </div>
              )}
            </div>
          </div>

        </article>

        {!image_no_cropping && (
          <div className={`container-fluid ${styles.smkContainer}`}>
            <div className='row'>
              <div className='col-xs-12'>
                <div
                  ref={node => this.nodeSMK = node}
                  className={styles.smk}
                >
                  <p><strong>Statens Museum for Kunst</strong></p>
                  <p>National Gallery of Denmark</p>
                </div>
              </div>
            </div>
          </div>
        )}

      </section>
    )
  }
}

export default withRouter(HeroFront)



// WEBPACK FOOTER //
// ./src/components/Hero/HeroFront.js